export type FsSeasonPointsRulesBase = {
  bonusAmount?: number | undefined;
  bonusType?: string | undefined;
  dqBonusAmount?: number | undefined;
  dqForceLast?: boolean | undefined;
  dqPoints?: number | undefined;
  finalistPoints?: number | undefined;
  ffBonusAmount?: number | undefined;
  ffForceLast?: boolean | undefined;
  ffPoints?: number | undefined;
};

export type FsPositionSeasonPointsRules = FsSeasonPointsRulesBase & {
  position: (number | string)[] | undefined;
};

export type FsWDLSeasonPointsRules = FsSeasonPointsRulesBase & {
  win: number | undefined;
  draw: number | undefined;
  loss: number | undefined;
};

export type FsSeasonPointsRules =
  | FsPositionSeasonPointsRules
  | FsWDLSeasonPointsRules;

export const isFsPositionSeasonPointsRules = (
  rules: FsSeasonPointsRules
): rules is FsPositionSeasonPointsRules => {
  return (rules as FsPositionSeasonPointsRules).position !== undefined;
};

export type FsAltSeasonPointRules = {
  matchIds: string[] | undefined;
  points: FsSeasonPointsRules | undefined;
};
